export * from './format-utils';

export const num = (v: string | undefined) => parseFloat(v || '0') || 0;

export function formatCurrency(v: string): string {
  const n = parseFloat(v?.replace(/[^0-9.-]/g, '') || '0') || 0;
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function stripCurrency(v: string): string {
  return v?.replace(/[^0-9.-]/g, '') || '';
}
